import React from 'react';
import LinkStyledSimple from './LinkStyledSimple';
// reassign our link component so it's a bit easier to read
const Link = LinkStyledSimple;
const baseLinkClasses = `ml8 mr8 miw18`;

export default function PaginationLinks({
  className,
  itemCount,
  itemsPerPage,
  currentPage,
  generatePath,
}) {
  const numPages = Math.ceil(itemCount / itemsPerPage);

  let cPage = parseInt(currentPage, 10) + 1;
  if(currentPage > numPages) {
    console.warn('something is off about the current page count');
    cPage = numPages;
  }

  const pageNumberArray = []
  if(numPages < 5) {
    for(let i = 0; i < numPages; i++) {
      pageNumberArray.push(i + 1)
    }
  }

  const numbers = (
    cPage === 1        ? (numPages >= 5 ? [ 2, 3, 4, 5 ] : pageNumberArray)
  : cPage === numPages ?  (numPages >= 5 ? [ numPages - 4, numPages - 3, numPages - 2, numPages - 1 ] : pageNumberArray)
  : [ cPage -2 , cPage - 1, cPage, cPage + 1, cPage + 2]
  )
  .filter(num => (
    // handle underflow and overflow
    (  num > 0
    && num < numPages
    && cPage < 4
    && cPage >= 4
    )
  ||
    // handle first few pages
    (  cPage < 4
    && num > 1
    )
  ||
    // handle last few pages 
    (  cPage >= 4
    && num < numPages)
  ));

  // perhaps calculations too clever for their own good
  return (
  <div className={`pagination-links dib ${ className || '' }`}>
    <div className="pagination-links__info mb16 fz14@sm fz16">
      Items { ((cPage-1) * itemsPerPage) + 1 } to { Math.min(cPage * itemsPerPage, itemCount) }  of { itemCount } total
    </div>
    <div className="pagination-links__links">
      {cPage > 1 &&
      <Link
        className="mr10"
        underlineFromCenter={true}
        to={generatePath(cPage - 1)}
      >
        <span className="dib mr8">&#9666;</span> Prev
      </Link>
      }
      <Link
        className={baseLinkClasses}
        underlineFromCenter={true}
        isActive={cPage === 1}
        to={generatePath(1)}
      >
        <span className="sr-only">page </span>
        1
      </Link>
      {numPages > 1 && numPages <= 3 &&
      numbers.map((num, i) => (
        <Link
          key={i}
          className={baseLinkClasses}
          underlineFromCenter={true}
          isActive={cPage === num}
          to={generatePath(num)}
        >
          <span className="sr-only">page </span>
          { num }
        </Link>
      ))
      }
      {(cPage > 3 && numPages > 5) &&
        <Link
          className={baseLinkClasses}
          underlineFromCenter={true}
          to={generatePath(numbers[0])}
        >
          . . .
        </Link>
      }
      {numPages > 3 &&
        numbers.map((num, i) => (
          <Link
            key={i}
            className={baseLinkClasses}
            underlineFromCenter={true}
            isActive={cPage === num}
            to={generatePath(num)}
            ariaCurrent={cPage === num ? 'page' : ''}
          >
            <span className="sr-only">page </span>
            { num }
          </Link>
        ))
      }
      {(cPage < numPages - 3 && numPages > 5) &&
        <Link
          className={baseLinkClasses}
          underlineFromCenter={true}
          to={generatePath(numbers[numbers.length - 1])}
        >
          . . .
        </Link>
      }
      {numPages > 5 &&
      <Link
        className={baseLinkClasses}
        underlineFromCenter={true}
        isActive={cPage === numPages}
        to={generatePath(numPages)}
      >
        <span className="sr-only">page </span>
        { numPages }
      </Link>
      }
      {cPage < numPages &&
      <Link
        className="ml10"
        underlineFromCenter={true}
        to={generatePath(cPage + 1)}
      >
        Next <span className="dib pb3 ml8 trf-rz180">&#9666;</span> 
      </Link>
      }
    </div>
  </div>
  )
}
